export default {
  raffle: {
    title: null,
    status: 'DRAFT',
    draft: true,
    description: null,
    app_description: null,
    start_date: null,
    end_date: null,
    segments: [],
    exclusion_segments: [],
    available_in_app: true,
    rules: {
      type: '',
      value: null,
      products: [],
    },
    optin: {
      active: false,
      terms: '',
    },
    units: [],
    prizes: [],
    app_start_exhibition_date: null,
    app_end_exhibition_date: null,
    register_number: null,
    min_series: null,
    max_series: null,
    lucky_number_generation_type: 'SECAP',
    max_numbers_per_person: null,
    max_numbers_per_coupon: null,
    banner_url: '',
    rules_url: '',
  },
  prizeBeingEdited: {
    title: '',
    image_url: null,
    raffle_date: null,
    quantity: null,
  },
  prizeFile: {
    file: null,
    fileName: '',
    fileType: null,
    allowedFileTypes: ['image/jpeg', 'image/jpg', 'image/png'],
    fileUrl: null,
    fileContent: null,
    isLoading: false,
  },
  luckyNumbersMetrics: {
    last_lucky_number: 0,
    first_lucky_number: 0,
    total_lucky_numbers: 0,
  },
  raffleParticipants: [],
  generateWinner: {
    raffleId: '',
    prizeId: '',
    numberOfWinners: 1,
    excludePastWinners: false,
    numberSearchMode: 'ASC',
    seriesSearchMode: 'ASC',
    secapNumber: null,
    image_url: '',
    color: '#FFFFFFFF',
  },
}
